import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const auth = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  verify: () => api.get('/auth/verify'),
  changePassword: (currentPassword, newPassword) =>
    api.post('/auth/change-password', { currentPassword, newPassword }),
};

export const evolution = {
  listMine: () => api.get('/evolution/mine'),
  getStatus: (instanceId) => api.get(`/evolution/${instanceId}/status`),
  getQRCode: (instanceId) => api.get(`/evolution/${instanceId}/qrcode`),
  getInfo: (instanceId) => api.get(`/evolution/${instanceId}/info`),
  disconnect: (instanceId) => api.post(`/evolution/${instanceId}/disconnect`),
  restart: (instanceId) => api.post(`/evolution/${instanceId}/restart`),
};

export const admin = {
  listUsers: () => api.get('/admin/users'),
  createUser: (username, password, role) => api.post('/admin/users', { username, password, role }),
  updateUserRole: (id, role) => api.put(`/admin/users/${id}`, { role }),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  listInstances: () => api.get('/admin/instances'),
  createInstance: (userId, name) => api.post('/admin/instances', { userId, name }),
  deleteInstance: (id) => api.delete(`/admin/instances/${id}`),
  grantAccess: (instanceId, userId) => api.post(`/admin/instances/${instanceId}/access`, { userId }),
  revokeAccess: (instanceId, userId) => api.delete(`/admin/instances/${instanceId}/access/${userId}`),
  getWebhook: (instanceId) => api.get(`/admin/instances/${instanceId}/webhook`),
  setWebhook: (instanceId, webhook) => api.put(`/admin/instances/${instanceId}/webhook`, webhook),
};

export default api;
